import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL


export const viewVehicleSuggetionsAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.get(`${apiBaseUrl}/superAdmin/ViewAllNewSuggestions`, {
      headers,
    });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}


export const approveVehicleSuggetionsAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(`${apiBaseUrl}/superAdmin/ManageVehicleMaster`,formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}


export const rejectVehicleSuggetionsAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(`${apiBaseUrl}/superAdmin/RejectNewSuggestions`,formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}



export const addVehicleApi = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(`${apiBaseUrl}/superAdmin/InsertManageVehicleMaster`,formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}


export const sendSuggestionEmailApi = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(`${apiBaseUrl}/superAdmin/sendEmailNewSuggestion`,formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}


export const changeActionAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(`${apiBaseUrl}/superAdmin/ChangeAction`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}